import React from "react";
import { Helmet } from "react-helmet-async";

const MetaTags = ({
  siteName,
  title,
  description,
  url,
  image,
  keywords,
  ogType = "website", // Default to 'website' for Open Graph
  twitterCard = "summary_large_image", // Default to 'summary_large_image' for Twitter
  price, 
  availability, 
  currency
}:any) => {

  return (
    <Helmet>
      {/* General Meta Tags */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {url && <link rel="canonical" href={url} />}

      {/* PWA Meta Tags */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      {siteName && <meta name="application-name" content={siteName} />}
      {siteName && <meta name="apple-mobile-web-app-title" content={siteName} />}

      {/* Open Graph (for social media sharing) */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:type" content={ogType} />
      {siteName && <meta property="og:site_name" content={siteName} />}
      {price && <meta property="product:price:amount" content={price} />}
      {currency && <meta property="product:price:currency" content={currency} />}
      {availability && <meta property="product:availability" content={availability} />}

      {/* Twitter Card (for Twitter sharing) */}
      <meta name="twitter:card" content={twitterCard} />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {url && <meta name="twitter:url" content={url} />}
    </Helmet>
  );
};

export default MetaTags;